import { useQuery } from '@tanstack/react-query';

import { botTypes } from '../types';

import { axios } from '@/libraries/axios';
import { ExtractFnReturnType, QueryConfig } from '@/libraries/react-query';
import { Departments } from '@/types';

export const getBotPages: botTypes.GetPages = (params) => {
  return axios.get('/bot/pages', { params });
};

type QueryFnType = typeof getBotPages;

type UseGetBotPagesOptions = {
  department: Departments;
  config?: QueryConfig<QueryFnType>;
};

export const useGetBotPages = ({ config = {}, department }: UseGetBotPagesOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    enabled: !!department,
    queryKey: ['bot-pages', department],
    queryFn: () => getBotPages({ department }),
  });
};
